import React, { useState } from "react";
import { Helmet } from "react-helmet-async";

// Import new images
import img1 from "../img/ai.jpg";
import img2 from "../img/ml.jpg";
import img3 from "../img/enterprise.jpg";
import img4 from "../img/website.jpg";
import img5 from "../img/data.jpg";
import img6 from "../img/cloud.jpg";
import img7 from "../img/cybersec.jpg";
import img8 from "../img/database.jpg";
import img9 from "../img/fullstack.jpg";
import img10 from "../img/iot.jpg";
import img11 from "../img/mne.jpg";
import img12 from "../img/kpi.jpg";
import img13 from "../img/impact.jpg";
import img14 from "../img/logframe.jpg";
import img15 from "../img/integratedgis.jpg";
import img16 from "../img/appliedgis.jpg";
import img17 from "../img/pim.jpg";
import img18 from "../img/business.jpg";
import img19 from "../img/management.jpg";

const portfolioItems = [
  {
    image: img1,
    title: "Artificial Intelligence",
    content:
      "Artificial Intelligence, is remarkably changing the decision making capabilities, in diverse fields. It can deliver outcomes that are accurate and efficient. AI’s inclusion in digital solutions, has impacted its potential manifold. This cutting edge technology, has been incorporated in our solutions.",
  },
  {
    image: img2,
    title: "Machine Learning",
    content:
      "Data Analytics becomes more powerful when machine learning is integrated with it. Appropriate models have been the hallmark of machine learning process. The algorithm propagates the data through these models rigorously, for predicting with precise accuracy. This disruptive technology is in our team’s domain knowledge.",
  },
  {
    image: img3,
    title: "Enterprise Solutions",
    content:
      "Enterprise solutions form the backbone of organisation ecosystem. The ecosystem comprises of, the to and fro information flow & its management. We provide a holistic front to backend solutions. The solutions are specific to the needs of the organisation.",
  },
  {
    image: img5,
    title: "Data Science and Analytics",
    content:
      "Data is pivotal decision making tool. Data visualisation and analytics  form the core ingredients of machine and deep learning processes. The precision, accuracy and efficiency solely dependent on data. Our development ecosystem uses data science and data analytics as its essential components.",
  },
  {
    image: img6,
    title: "Cloud Computing",
    content:
      "Cloud brings in innovation and is the future of technology. It now forms the foundation of digital world. It acts as a catalyst for growth. Cloud brings in security, and mobility to the digital environment. Business strategies are now being built around cloud.",
  },
  {
    image: img7,
    title: "Cyber Security",
    content:
      "With increasing threat perception in the digital age, cybersecurity is not only providing risk mitigation and compliance, but also security for growth. Cloud taking centre stage of business strategy, cybersecurity becomes imperative. Protecting business makes cybersecurity essential.",
  },
  {
    image: img8,
    title: "Database Solutions",
    content:
      "Cloud taking centre stage of business strategies, unstructured and structured data management, becomes a core issue. The processes of database management, will build the foundation of all innovative technologies being applied to the development. We provide innovative database management solutions, catering to latest technologies being applied.",
  },
  {
    image: img9,
    title: "Full Stack App Development",
    content:
      "Full stack process paves a path for business success. Designing and curating front end for applications, is an expertise of our team. The team is well versed with backend development, database design, API integration, mobile app development, full stack development with AI integration and full stack migration and porting. We also provide maintenance and support.",
  },
  {
    image: img10,
    title: "IoT",
    content:
      "Connecting products and processes, to add exponential value, to technological intelligence, has become the latest advancement. It appears that we are bringing life to objects. The entire developed ecosystem, provides a cutting edge technology, that makes handling complex functionalities, with ease.",
  },
  {
    image: img4,
    title: "E-Commerce and Application Development",
    content:
      "At Ethervue, we deliver premium website, e-commerce, and application development services with a focus on creative design and seamless UI/UX. Our solutions integrate advanced cloud technologies, ensuring scalability and performance. We specialize in building secure, high-performance e-commerce platforms and custom applications, seamlessly connecting front-end designs with robust back-end databases, offering high-end clients innovative, business-driven digital experiences.",
  },
  {
    image: img11,
    title: "Project Monitoring and Evaluation",
    content:
      "Effective and efficient implementation of any project, is based on continuous monitoring of milestones, at different points of time. One needs effective tools, and thorough professional approach, to do these. This is totally based on timelines. These tools, finally lead to evaluate, the outcomes of the project, leading it to its intended objective.",
  },
  {
    image: img12,
    title: "Develop Key Performance Indicators",
    content:
      "Measurement of progress/performance requires developing valid indicators. The development of effective performance indicators  require in-depth study of the project, and accordingly develop scientific indicators. These key performance indicators, are then utilised to determine project outcomes, and ultimately project objective.",
  },
  {
    image: img13,
    title: "Impact Assessment",
    content:
      "Lasting impression of the project, on the masses, in the long run, was its ultimate intended objective. To assess it with precision, requires holistic understanding of the project, and ultimately develop scientific indicators, that logically leads to, derivatives of assessment. Long time impact, was the ultimate objective, for which the project was conceived.",
  },
  {
    image: img14,
    title: "Logframe Analysis",
    content:
      "Logframe analysis is a matrix, that requires customised design and development, according to a specific project. All project monitoring and evaluation methods, like key performance indicators, project outcomes & objectives, form the framework components of the matrix.",
  },
  {
    image: img15,
    title: "Integrated Web Based GIS",
    content:
      "Web based GIS is existent, and so is Management Information System as an entity. There has always been a need for integration between the two. This will broaden the perspective for effective decision making. It will showcase digital information on spatial platform. The data visualisation will be self explanatory.",
  },
  {
    image: img16,
    title: "Applied GIS",
    content:
      "Many land related information are depicted effectively on GIS platforms. In case of certain transformations occurring, in these information, due to some interventions, one would like these to be reflected separately on the GIS platform. The role of applied GIS, is needed here.",
  },
  {
    image: img17,
    title: "Participatory Irrigation Management",
    content:
      "Water resource management, has become a challenge, for water resources sector. The need of the hour, is to utilise the services of its users, at different segments of the infrastructure. This requires developing legal framework, for their inclusion as stakeholder. Empowering them for various aspects of water management, as well as equipping them for operations and maintenance of existing infrastructure, requires expertise. All aspects of water resources management are covered through participatory irrigation management.",
  },
  {
    image: img18,
    title: "Business Promotions",
    content:
      "Business promotion is an essential strategy, to pitch it to the intended audience. Physical communication, traditional media, digital media and sponsorship are some of the methods deployed for business promotion. Some effective digital media platforms are social media, digital marketing, search engine optimisation etc. Effective communication, through any of these employed promotional strategies, will lead to better outcomes.",
  },
  {
    image: img19,
    title: "Management Consultancy",
    content:
      "Effective and efficient management of functionalities, have become necessary for better performance. Technological intervention in processes, change management assistance, process analysis, operational improvement services, identification of problems and suggest improvements etc. are some of the broad areas of management consultancy. Some of its specific tasks are financial management consulting, digital management consulting, technology management consulting and operations management consulting.",
  }
];

const Portfolio = () => {
  const [selectedContent, setSelectedContent] = useState(null);

  return (
    <section id="work" className="portfolio-mf sect-pt4 route" aria-label="Our Services">
      <Helmet>
        <title>Our Services | AI, ML, Web Development, and More</title>
        <meta name="description" content="Explore our expertise in AI, ML, cloud computing, cybersecurity, full-stack development, and more." />
        <meta name="keywords" content="Artificial Intelligence, Machine Learning, Cloud Computing, Cybersecurity, Web Development, Data Analytics" />
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h2 className="title-a">What We Do?</h2>
              <p className="subtitle-a">
                Showcasing our expertise in various technological domains.
              </p>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {portfolioItems.map((item, index) => (
            <div className="col-md-4" key={index}>
              <div className="work-box">
                <div className="work-img">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="img-fluid"
                    loading="lazy"
                  />
                </div>
                <div className="work-content">
                  <div className="row">
                    <div className="col-sm-12 text-center">
                      <h3
                        className="w-title"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setSelectedContent(
                            selectedContent === index ? null : index
                          )
                        }
                      >
                        {item.title}
                      </h3>
                      {selectedContent === index && (
                        <p className="w-text">{item.content}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;